import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/common/Layout";
import AdminPanel from "./pages/AdminPanel";
import SubscriptionsPage from "./pages/SubscriptionsPage";
import { restoreSession } from "./slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import AdminDocumentTypesPage from "./pages/AdminDocumentTypesPage";
import AuditLogPage from "./pages/AuditLogPage";
import AdminCategoriesPage from "./pages/AdminCategoriesPage";
import AdminFieldDefinitionsPage from "./pages/AdminFieldDefinitionsPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";

export default function App() {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const isLoading = useSelector((state) => state.user.isLoading);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoading && isLoggedIn) {
      dispatch(restoreSession());
    }
  }, [dispatch]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout/>}>
          <Route path="login" element={<LoginPage/>}/>
          <Route index element={<DashboardPage />} />
          <Route path="admin/dashboard" element={<DashboardPage/>}/>
          <Route path="admin/panel" element={<AdminPanel/>}/>
          <Route path="admin/audit-logs" element={<AuditLogPage/>}/>
          <Route path="admin/subscriptions" element={<SubscriptionsPage/>}/>
          <Route path="admin/categories" element={<AdminCategoriesPage/>}/>
          <Route path="admin/document-types" element={<AdminDocumentTypesPage/>}/>
          <Route path="admin/field-definitions" element={<AdminFieldDefinitionsPage/>}/>
        </Route>
      </Routes>
    </Router>
  );
}
